export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const FUNCTION_URL = process.env.REACT_APP_FUNCTION_URL;
// export const FUNCTION_URL = 'http://127.0.0.1:5001/currency-calculator-d6bdf/europe-west1/scraper';

//'https://www.bnb.bg/Statistics/StExternalSector/StExchangeRates/StERForeignCurrencies/index.htm?downloadOper=&group1=first&firstDays=26&firstMonths=06&firstYear=2018&search=true&showChart=false&showChartButton=false'